import { BlueprintContext } from '../../blueprint-context/blueprint-context.class';
import { CountertopMaterial } from '../countertop-material.class';
import { COUNTERTOP_MAX_THICKNESS, COUNTERTOP_MIN_THICKNESS } from '../constants';

export const setCountertopThicknessCfn = (countertopMaterial: CountertopMaterial, t: number, context: BlueprintContext): number => {
	const { logger } = context;
	let { thickness } = countertopMaterial;

	if (!countertopMaterial.override) {
		logger.warn('countertop is set to sync, thickness not set');
	} else if (t > COUNTERTOP_MAX_THICKNESS) {
		logger.info(`countertop thickness cannot by set to ${t}, it exceeds max ${COUNTERTOP_MAX_THICKNESS}. Max value used`);
		thickness = COUNTERTOP_MAX_THICKNESS;
	} else if (t < COUNTERTOP_MIN_THICKNESS) {
		logger.info(`countertop thickness cannot by set to ${t}, it's unde the min ${COUNTERTOP_MIN_THICKNESS}. Min value used`);
		thickness = COUNTERTOP_MIN_THICKNESS;
	} else {
		thickness = t;
	}

	return thickness;
}
